import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../constant/helpLinks"
import isValidEstManuFactoryId from "../../../service/visibleValidator/isValidEstManuFactoryId"

import img from "./estManuFactoryId.png"
import japan from "./japan.png"
import korea from "./korea.png"
import taiwan from "./taiwan.png"

const 製造工場 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { estManuFactoryId: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="製造工場" helpURL={HELP_LINKS.製造工場} src={img}>
      <RadioGroup
        name={FIELD_NAMES.製造工場}
        selectedValue={values.estManuFactoryId}
        onChange={handlers.radio}
        shouldRender={(value) => isValidEstManuFactoryId(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.製造工場.指定なし.value}>指定なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.製造工場.韓国.value} prefixImageSrc={korea}>
            韓国
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.製造工場.台湾.value} prefixImageSrc={taiwan}>
            台湾
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.製造工場["日本(リジッド)"].value} prefixImageSrc={japan}>
            日本
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.製造工場["日本(フレキシブル)"].value} prefixImageSrc={japan}>
            日本
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.estManuFactoryId} />
    </OneClickField>
  )
}

export default 製造工場
